function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoordinates({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "499px",
    height: "500px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b9d9f8",
    d: "M 234.5,-0.5 C 243.833,-0.5 253.167,-0.5 262.5,-0.5C 345.037,6.50625 409.871,43.8396 457,111.5C 482.38,150.472 496.213,193.138 498.5,239.5C 498.5,244.5 498.5,249.5 498.5,254.5C 495.433,330.899 464.767,393.732 406.5,443C 331.815,500.002 249.815,513.336 160.5,483C 74.7103,447.632 22.2103,384.466 3,293.5C 1.73534,285.032 0.568672,276.699 -0.5,268.5C -0.5,255.5 -0.5,242.5 -0.5,229.5C 9.08103,143.813 50.4144,78.3127 123.5,33C 158.121,13.5996 195.121,2.43292 234.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3892ec",
    d: "M 243.5,120.5 C 244.449,119.848 245.615,119.514 247,119.5C 249.008,119.307 250.508,119.974 251.5,121.5C 248.904,120.735 246.237,120.401 243.5,120.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0271e7",
    d: "M 243.5,120.5 C 246.237,120.401 248.904,120.735 251.5,121.5C 253.371,121.859 254.871,122.859 256,124.5C 258.083,129.002 260.417,133.335 263,137.5C 264.514,143.123 262.681,147.123 257.5,149.5C 255.511,171.141 254.844,193.141 255.5,215.5C 249.5,215.5 243.5,215.5 237.5,215.5C 237.831,193.327 237.497,171.327 236.5,149.5C 236.167,149.5 235.833,149.5 235.5,149.5C 232.318,147.46 230.985,144.46 231.5,140.5C 231.553,135.739 233.219,131.739 236.5,128.5C 238.326,126.853 239.66,124.853 240.5,122.5C 240.973,121.094 241.973,120.427 243.5,120.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4094ec",
    d: "M 240.5,122.5 C 239.66,124.853 238.326,126.853 236.5,128.5C 236.845,125.802 238.178,123.802 240.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#127ce9",
    d: "M 236.5,149.5 C 237.497,171.327 237.831,193.327 237.5,215.5C 243.5,215.5 249.5,215.5 255.5,215.5C 255.5,215.833 255.5,216.167 255.5,216.5C 249.167,216.5 242.833,216.5 236.5,216.5C 236.5,194.167 236.5,171.833 236.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#68aef0",
    d: "M 235.5,149.5 C 235.833,149.5 236.167,149.5 236.5,149.5C 236.5,171.833 236.5,194.167 236.5,216.5C 242.833,216.5 249.167,216.5 255.5,216.5C 255.833,216.5 256.167,216.5 256.5,216.5C 249.687,217.491 242.687,217.825 235.5,217.5C 235.5,194.833 235.5,172.167 235.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3f94ec",
    d: "M 257.5,149.5 C 256.511,171.758 256.178,194.092 256.5,216.5C 256.167,216.5 255.833,216.5 255.5,216.5C 255.5,216.167 255.5,215.833 255.5,215.5C 254.844,193.141 255.511,171.141 257.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3a94ec",
    d: "M 250.5,228.5 C 245.167,228.833 239.833,229.167 234.5,229.5C 237.55,228.065 240.883,227.398 244.5,227.5C 246.696,227.505 248.696,227.838 250.5,228.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0472e7",
    d: "M 250.5,228.5 C 259.538,229.573 266.871,233.573 272.5,240.5C 272.427,242.027 273.094,243.027 274.5,243.5C 276.213,246.384 277.713,249.384 279,252.5C 279.683,259.861 279.517,267.195 278.5,274.5C 276.592,275.486 275.592,277.152 275.5,279.5C 270.72,285.945 264.72,290.945 257.5,294.5C 251.848,295.032 246.181,295.365 240.5,295.5C 226.955,293.297 217.955,285.63 213.5,272.5C 212.259,265.813 212.259,259.146 213.5,252.5C 216.639,241.359 223.639,233.692 234.5,229.5C 239.833,229.167 245.167,228.833 250.5,228.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#439aed",
    d: "M 272.5,240.5 C 273.906,240.973 274.573,241.973 274.5,243.5C 273.094,243.027 272.427,242.027 272.5,240.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a7cff6",
    d: "M 258.5,256.5 C 259.299,259.43 259.632,262.43 259.5,265.5C 258.306,269.363 255.973,272.363 252.5,274.5C 248.167,275.833 243.833,275.833 239.5,274.5C 237.351,272.954 235.184,271.288 233,269.5C 229.36,253.807 235.527,246.973 251.5,249C 254.866,250.652 257.199,253.152 258.5,256.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0772e7",
    d: "M 248.5,251.5 C 252.107,251.565 254.44,253.231 255.5,256.5C 255.5,260.5 255.5,264.5 255.5,268.5C 254.167,269.5 252.833,270.5 251.5,271.5C 247.833,272.833 244.167,272.833 240.5,271.5C 234.031,267.114 232.865,261.447 237,254.5C 238.113,253.695 239.279,253.028 240.5,252.5C 243.054,251.612 245.721,251.279 248.5,251.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5aa4ee",
    d: "M 248.5,251.5 C 245.721,251.279 243.054,251.612 240.5,252.5C 241.334,251.252 242.667,250.585 244.5,250.5C 246.045,250.511 247.378,250.844 248.5,251.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#56a2ee",
    d: "M 213.5,252.5 C 212.259,259.146 212.259,265.813 213.5,272.5C 212.778,272.082 212.278,271.416 212,270.5C 211.333,264.833 211.333,259.167 212,253.5C 212.383,252.944 212.883,252.611 213.5,252.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2e88ea",
    d: "M 255.5,256.5 C 256.117,256.611 256.617,256.944 257,257.5C 257.167,259 257.333,260.5 257.5,262C 257.664,264.544 256.997,266.71 255.5,268.5C 255.5,264.5 255.5,260.5 255.5,256.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5fa7f0",
    d: "M 258.5,256.5 C 259.117,256.611 259.617,256.944 260,257.5C 260.801,260.367 260.634,263.034 259.5,265.5C 259.632,262.43 259.299,259.43 258.5,256.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0572e7",
    d: "M 183.5,301.5 C 181.847,301.66 180.514,302.326 179.5,303.5C 171.186,308.804 162.853,314.137 154.5,319.5C 153.711,322.646 153.045,325.813 152.5,329C 151.456,330.174 150.456,331.341 149.5,332.5C 140.833,333.833 132.167,333.833 123.5,332.5C 122.173,330.165 121.173,327.665 120.5,325C 121.896,320.956 123.562,317.123 125.5,313.5C 126.906,313.027 127.573,312.027 127.5,310.5C 128.203,308.284 129.536,306.451 131.5,305C 135.167,304.667 138.833,304.333 142.5,304C 144.522,301.991 146.855,300.491 149.5,299.5C 152.267,299.13 154.267,297.796 155.5,295.5C 155.833,295.5 156.167,295.5 156.5,295.5C 158.826,294.855 160.493,293.522 161.5,291.5C 168.597,286.295 175.931,281.628 183.5,277.5C 185.027,277.573 186.027,276.906 186.5,275.5C 189.31,272.59 192.643,271.09 196.5,271C 199.41,275.906 202.41,280.739 205.5,285.5C 203.005,289.646 199.339,292.312 194.5,293.5C 190.589,295.943 186.922,298.61 183.5,301.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#338eeb",
    d: "M 240.5,271.5 C 244.167,272.833 247.833,272.833 251.5,271.5C 251.389,272.117 251.056,272.617 250.5,273C 247.5,273.667 244.5,273.667 241.5,273C 240.944,272.617 240.611,272.117 240.5,271.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0572e7",
    d: "M 351.5,303.5 C 355.167,302.167 358.833,302.167 362.5,303.5C 367.437,309.259 370.77,315.926 372.5,323.5C 371.763,325.97 370.763,328.304 369.5,330.5C 361.623,332.752 353.623,333.085 345.5,331.5C 341.605,329.354 339.439,326.021 339,321.5C 336.521,319.686 334.021,318.019 331.5,316.5C 331.027,315.094 330.027,314.427 328.5,314.5C 314.5,305.5 300.5,296.5 286.5,287.5C 286.629,285.784 286.962,284.117 287.5,282.5C 289.617,277.91 292.45,273.91 296,270.5C 313.951,281.759 331.951,293.092 350,304.5C 350.765,304.43 351.265,304.097 351.5,303.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#539fee",
    d: "M 186.5,275.5 C 186.027,276.906 185.027,277.573 183.5,277.5C 183.973,276.094 184.973,275.427 186.5,275.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#308ceb",
    d: "M 239.5,274.5 C 243.833,275.833 248.167,275.833 252.5,274.5C 249.273,277.457 245.44,278.124 241,276.5C 239.97,276.164 239.47,275.497 239.5,274.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7bb7f2",
    d: "M 278.5,274.5 C 278.25,276.674 277.25,278.341 275.5,279.5C 275.592,277.152 276.592,275.486 278.5,274.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4799ed",
    d: "M 287.5,282.5 C 286.962,284.117 286.629,285.784 286.5,287.5C 283.97,285.67 284.303,284.004 287.5,282.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3d91ec",
    d: "M 161.5,291.5 C 160.493,293.522 158.826,294.855 156.5,295.5C 157.507,293.478 159.174,292.145 161.5,291.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2b8eeb",
    d: "M 257.5,294.5 C 251.9,296.465 246.233,296.798 240.5,295.5C 246.181,295.365 251.848,295.032 257.5,294.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3e92ec",
    d: "M 155.5,295.5 C 154.267,297.796 152.267,299.13 149.5,299.5C 151.118,297.684 153.118,296.351 155.5,295.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#55a5ef",
    d: "M 362.5,303.5 C 358.833,302.167 355.167,302.167 351.5,303.5C 351.611,302.883 351.944,302.383 352.5,302C 355.5,301.333 358.5,301.333 361.5,302C 362.056,302.383 362.389,302.883 362.5,303.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#60a7ef",
    d: "M 183.5,301.5 C 182.713,303.104 181.38,303.771 179.5,303.5C 180.514,302.326 181.847,301.66 183.5,301.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#65a8ef",
    d: "M 127.5,310.5 C 127.573,312.027 126.906,313.027 125.5,313.5C 125.427,311.973 126.094,310.973 127.5,310.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4b9cee",
    d: "M 328.5,314.5 C 330.027,314.427 331.027,315.094 331.5,316.5C 329.973,316.573 328.973,315.906 328.5,314.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#61a9f0",
    d: "M 369.5,330.5 C 369.423,331.75 368.756,332.583 367.5,333C 360.5,333.667 353.5,333.667 346.5,333C 345.944,332.617 345.611,332.117 345.5,331.5C 353.623,333.085 361.623,332.752 369.5,330.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2483e9",
    d: "M 123.5,332.5 C 132.167,333.833 140.833,333.833 149.5,332.5C 149.389,333.117 149.056,333.617 148.5,334C 142.992,334.417 137.492,334.917 132,335.5C 128.592,335.755 125.759,334.755 123.5,332.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoordinates);
export default __webpack_public_path__ + "static/media/coordinates.ba053271372eb8aeb60b6f407403c7a9.svg";
export { ForwardRef as ReactComponent };